exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-buttons>.btn[data-v-6f7ddf1e]{white-space:nowrap}.action-buttons>.btn[data-v-6f7ddf1e]:not(:first-child){margin-left:.25rem}.action-buttons>.btn[data-v-6f7ddf1e]:not(:last-child){margin-right:.25rem}", ""]);

// exports
